var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99329 14.3341C4.88662 14.3341 3.77329 13.9141 2.92662 13.0674C1.23995 11.3741 1.23995 8.6274 2.92662 6.94073C3.11995 6.7474 3.43995 6.7474 3.63329 6.94073C3.82662 7.13406 3.82662 7.45406 3.63329 7.6474C2.33329 8.9474 2.33329 11.0607 3.63329 12.3607C4.93329 13.6607 7.04662 13.6607 8.34662 12.3607C8.97329 11.7341 9.31995 10.8941 9.31995 10.0007C9.31995 9.11406 8.97329 8.27406 8.34662 7.64073C8.15329 7.4474 8.15329 7.1274 8.34662 6.93406C8.53995 6.74073 8.85995 6.74073 9.05329 6.93406C9.87329 7.75406 10.32 8.84073 10.32 10.0007C10.32 11.1607 9.86662 12.2474 9.05329 13.0674C8.21329 13.9141 7.10662 14.3341 5.99329 14.3341Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7134 9.44081C12.5867 9.44081 12.4601 9.39414 12.3601 9.29414C12.1667 9.10081 12.1667 8.78081 12.3601 8.58747C13.7267 7.22081 13.7267 5.00081 12.3601 3.64081C10.9934 2.27414 8.77339 2.27414 7.41339 3.64081C6.75339 4.30081 6.38672 5.18081 6.38672 6.11414C6.38672 7.04747 6.75339 7.92747 7.41339 8.58747C7.60672 8.78081 7.60672 9.10081 7.41339 9.29414C7.22005 9.48747 6.90005 9.48747 6.70672 9.29414C5.86005 8.44747 5.38672 7.31414 5.38672 6.11414C5.38672 4.91414 5.85339 3.78081 6.70672 2.93414C8.46005 1.18081 11.3134 1.18081 13.0734 2.93414C14.8267 4.68747 14.8267 7.54747 13.0734 9.30081C12.9734 9.39414 12.8401 9.44081 12.7134 9.44081Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link-2.a7bb5899.svg";
export { ForwardRef as ReactComponent };